import React from "react";
import { useParams } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../../styles/ProjectGallery.css";

// Import images
import Nakshatra_Veda1_Gallery_image1 from "../../images/Nakshatra_Veda1_Gallery_image1.png";
import Nakshatra_Veda1_Gallery_image2 from "../../images/Nakshatra_Veda1_Gallery_image2.png";
import Nakshatra_Veda1_Gallery_image3 from "../../images/Nakshatra_Veda1_Gallery_image3.png";
import Nakshatra_Veda1_Gallery_image4 from "../../images/Nakshatra_Veda1_Gallery_image4.png";
import Nakshatra_Veda1_Gallery_image5 from "../../images/Nakshatra_Veda1_Gallery_image5.png";
import Nakshatra_Veda1_Gallery_image6 from "../../images/Nakshatra_Veda1_Gallery_image6.png";
import Nakshatra_Veda1_Gallery_image7 from "../../images/Nakshatra_Veda1_Gallery_image7.png";
import Nakshatra_Veda1_Gallery_image8 from "../../images/Nakshatra_Veda1_Gallery_image8.png";

import Nakshatra_Aazatha_Gallery_image1 from "../../images/nakshatra-aazstha-clubhouse.png";
import Nakshatra_Aazatha_Gallery_image2 from "../../images/nakshatra-aazstha-gallery-entrance.png";
import Nakshatra_Aazatha_Gallery_image3 from "../../images/nakshatra-aazstha-garden-landscaping.png";
import Nakshatra_Aazatha_Gallery_image4 from "../../images/nakshatra-aazstha-apartment-building.png";
import Nakshatra_Aazatha_Gallery_image5 from "../../images/nakshatra-aazstha-parking-area.png";
import Nakshatra_Aazatha_Gallery_image6 from "../../images/nakshatra-aazstha-gym-fitness-center.png";
import Nakshatra_Aazatha_Gallery_image7 from "../../images/nakshatra-aazstha-childrens-play-area.png";
import Nakshatra_Aazatha_Gallery_image8 from "../../images/nakshatra-aazstha-walking-track.png";
import Nakshatra_Aazatha_Gallery_image9 from "../../images/nakshatra-aazstha-swimming-pool.png";
import Nakshatra_Aazatha_Gallery_image10 from "../../images/nakshatra-aazstha-rooftop-lounge.png";
import Nakshatra_Aazatha_Gallery_image11 from "../../images/nakshatra-aazstha-night-view.png";
import Nakshatra_Aazatha_Gallery_image12 from "../../images/nakshatra-aazstha-event-space.png";
import Nakshatra_Aazatha_Gallery_image13 from "../../images/nakshatra-aazstha-complete-site-view.png";

import Nakshatra_Gokul_Gallery_image1 from "../../images/nakshatra-gokul-gallery-entrance.png";
import Nakshatra_Gokul_Gallery_image2 from "../../images/nakshatra-gokul-gallery-lobby.png";
import Nakshatra_Gokul_Gallery_image3 from "../../images/nakshatra-gokul-gallery-apartment-interior.png";
import Nakshatra_Gokul_Gallery_image4 from "../../images/nakshatra-gokul-gallery-clubhouse.png";
import Nakshatra_Gokul_Gallery_image5 from "../../images/nakshatra-gokul-gallery-evening-view.png";
import Nakshatra_Gokul_Gallery_image6 from "../../images/nakshatra-gokul-gallery-terrace-view.png";
import Nakshatra_Gokul_Gallery_image7 from "../../images/nakshatra-gokul-gallery-fitness-zone.png";
import Nakshatra_Gokul_Gallery_image8 from "../../images/nakshatra-gokul-gallery-play-area.png";
import Nakshatra_Gokul_Gallery_image9 from "../../images/nakshatra-gokul-gallery-garden-view.png";

import Nakshatra_Prithvi_Gallery_image1 from "../../images/nakshatra-prithvi-gallery-image1.png";
import Nakshatra_Prithvi_Gallery_image2 from "../../images/nakshatra-prithvi-gallery-image2.png";
import Nakshatra_Prithvi_Gallery_image3 from "../../images/nakshatra-prithvi-gallery-image3.png";
import Nakshatra_Prithvi_Gallery_image4 from "../../images/nakshatra-prithvi-gallery-image4.png";
import Nakshatra_Prithvi_Gallery_image5 from "../../images/nakshatra-prithvi-gallery-image5.png";
import Nakshatra_Prithvi_Gallery_image6 from "../../images/nakshatra-prithvi-gallery-image6.png";
import Nakshatra_Prithvi_Gallery_image7 from "../../images/nakshatra-prithvi-gallery-image7.png";
import Nakshatra_Prithvi_Gallery_image8 from "../../images/nakshatra-prithvi-gallery-image8.png";
import Nakshatra_Prithvi_Gallery_image9 from "../../images/nakshatra-prithvi-gallery-image9.png";
import Nakshatra_Prithvi_Gallery_image10 from "../../images/nakshatra-prithvi-gallery-image10.png";
import Nakshatra_Prithvi_Gallery_image11 from "../../images/nakshatra-prithvi-gallery-image11.png";
import Nakshatra_Prithvi_Gallery_image12 from "../../images/nakshatra-prithvi-gallery-image12.png";

import Nakshatra_Aarambh_Gallery_image1 from "../../images/Nakshatra_Aarambh_Gallery_image1.png";
import Nakshatra_Aarambh_Gallery_image2 from "../../images/Nakshatra_Aarambh_Gallery_image2.png";
import Nakshatra_Aarambh_Gallery_image3 from "../../images/Nakshatra_Aarambh_Gallery_image3.png";

import ShreeRamNagar_Gallery_image1 from '../../images/shree-ram-nagar-gallery-image1.png'
import ShreeRamNagar_Gallery_image2 from '../../images/shree-ram-nagar-gallery-image2.png'
import ShreeRamNagar_Gallery_image3 from '../../images/shree-ram-nagar-gallery-image3.png'
import ShreeRamNagar_Gallery_image4 from '../../images/shree-ram-nagar-gallery-image4.png'
import ShreeRamNagar_Gallery_image5 from '../../images/shree-ram-nagar-gallery-image5.png'
import ShreeRamNagar_Gallery_image6 from '../../images/shree-ram-nagar-gallery-image6.png'
import ShreeRamNagar_Gallery_image7 from '../../images/shree-ram-nagar-gallery-image7.png'

import Nakshatra_Auris_Gallery_image1 from '../../images/nakshatra-auris-gallery-image1.png'
import Nakshatra_Auris_Gallery_image2 from '../../images/nakshatra-auris-gallery-image2.png'
import Radheshyam_Heights from "../../images/Radheshyam_Heights.jpg";
import Nakshatra_Nirvana from "../../images/Nakshatra_Nirvana.jpg"
import Nirvana_Carousel from "../../images/nakshatra-nirvana-elevation.jpg";
import Nirvana_project from "../../images/nakshatra-nirvana-main-banner.jpg"
import Radhysham1 from "../../images/radheshyam-heights-slide1.jpg"
import Radhysham2 from "../../images/radheshyam-heights-slide2.jpg"
import Radhysham3 from "../../images/radheshyam-heights-slide3.jpg"



import leftArrow from "../../images/left-arrow.png";
import rightArrow from "../../images/right-arrow.png";

const ProjectGalleryDesktop = () => {
  const params = useParams(); 

  const { projectId } = params;

  // Define image sets for each project
  const imageSets = {
    "nakshatra-veda-i": [
      {link :Nakshatra_Veda1_Gallery_image1},
      {link :Nakshatra_Veda1_Gallery_image2},
      {link :Nakshatra_Veda1_Gallery_image3},
      {link :Nakshatra_Veda1_Gallery_image4},
      {link :Nakshatra_Veda1_Gallery_image5},
      {link :Nakshatra_Veda1_Gallery_image6},
      {link :Nakshatra_Veda1_Gallery_image7},
      {link :Nakshatra_Veda1_Gallery_image8},
    ],
    "nakshatra-aazstha": [
      {link :Nakshatra_Aazatha_Gallery_image2},
      {link :Nakshatra_Aazatha_Gallery_image1},
      {link :Nakshatra_Aazatha_Gallery_image3},
      {link :Nakshatra_Aazatha_Gallery_image4},
      {link :Nakshatra_Aazatha_Gallery_image5},
      {link :Nakshatra_Aazatha_Gallery_image6},
      {link :Nakshatra_Aazatha_Gallery_image7},
      {link :Nakshatra_Aazatha_Gallery_image8},
      {link :Nakshatra_Aazatha_Gallery_image9},
      {link :Nakshatra_Aazatha_Gallery_image10},
      {link :Nakshatra_Aazatha_Gallery_image11},
      {link :Nakshatra_Aazatha_Gallery_image12},
      {link :Nakshatra_Aazatha_Gallery_image13},
    ],
    "nakshatra-gokul": [
      {link :Nakshatra_Gokul_Gallery_image1 ,alt :"Main entrance gate view"},
      {link :Nakshatra_Gokul_Gallery_image2, alt :"Reception and lobby area"},
      {link :Nakshatra_Gokul_Gallery_image3 ,alt:"Interior model apartment"},
      {link :Nakshatra_Gokul_Gallery_image4 ,alt:"Clubhouse exterior in the project"},
      {link :Nakshatra_Gokul_Gallery_image5 ,alt:"Evening view of building elevation"},
      {link :Nakshatra_Gokul_Gallery_image6 ,alt:"Terrace area of Nakshatra Gokul"},
      {link :Nakshatra_Gokul_Gallery_image7 ,alt:"Fitness area in amenities zone"},
      {link :Nakshatra_Gokul_Gallery_image8 ,alt:"Kids play area in Nakshatra Gokul"},
      {link :Nakshatra_Gokul_Gallery_image9 ,alt:"Garden and walking path view"},
    ],
    "nakshatra-prithvi": [

      {link :Nakshatra_Prithvi_Gallery_image1,alt:"Nakshatra Prithvi entrance"},
      {link :Nakshatra_Prithvi_Gallery_image2,alt:"Lobby area at Nakshatra Prithvi"},
      {link :Nakshatra_Prithvi_Gallery_image3,alt:"Model apartment interior"},
      {link : Nakshatra_Prithvi_Gallery_image4,alt:"Clubhouse exterior view"},
      {link :Nakshatra_Prithvi_Gallery_image5,alt:"Children play area"},
      {link :Nakshatra_Prithvi_Gallery_image6,alt:"Garden and walking track"},
      {link :Nakshatra_Prithvi_Gallery_image7,alt:"Fitness zone in the project"},
      {link :Nakshatra_Prithvi_Gallery_image8,alt:"Swimming pool view"},
      {link :Nakshatra_Prithvi_Gallery_image9,alt:"Evening view of Nakshatra Prithvi"},
      {link :Nakshatra_Prithvi_Gallery_image10,alt:"Balcony view of apartments"},
      {link :Nakshatra_Prithvi_Gallery_image11,alt:"Rooftop terrace view"},
      {link :Nakshatra_Prithvi_Gallery_image12,alt:"Night view of building"}
    ],
    "nakshatra-aarambh": [
      {link :Nakshatra_Aarambh_Gallery_image1},
      {link :Nakshatra_Aarambh_Gallery_image2},
      {link :Nakshatra_Aarambh_Gallery_image3},
    ],
    "shree-ram-nagar":[
      {link :ShreeRamNagar_Gallery_image1,alt:"Shree Ram Nagar Gallery Slide 1"},
      {link :ShreeRamNagar_Gallery_image2,alt:"Shree Ram Nagar Gallery Slide 2"},
      {link :ShreeRamNagar_Gallery_image3,alt:"Shree Ram Nagar Gallery Slide 3"},
      {link :ShreeRamNagar_Gallery_image4,alt:"Shree Ram Nagar Gallery Slide 4"},
      {link :ShreeRamNagar_Gallery_image5,alt:"Shree Ram Nagar Gallery Slide 5"},
      {link :ShreeRamNagar_Gallery_image6,alt:"Shree Ram Nagar Gallery Slide 6"},
      {link :ShreeRamNagar_Gallery_image7,alt:"Shree Ram Nagar Gallery Slide 7"}
    ],
    "nakshatra-auris":[
      {link :Nakshatra_Auris_Gallery_image1,alt:"Nakshatra Auris Gallery Slide 1"},
      {link :Nakshatra_Auris_Gallery_image2,alt:"Nakshatra Auris Gallery Slide 2"},
    ],
    "radhe-shyam-heights":[
     {link :Radhysham1,alt:"Radhe Shyam Heights Slide 1"},
     {link :Radhysham2,alt:"Radhe Shyam Heights Slide 2"},
     {link :Radhysham3,alt:"Radhe Shyam Heights Slide 3"}
    ],
    "nakshatra-nirvana":[
      {link :Nirvana_project ,alt:"Nakshatra Nirvana Main Banner"},
      {link :Nirvana_Carousel,alt:"Nakshatra Nirvana Elevation"},
    ]
  };

  // Select images based on projectId
  const images = imageSets[projectId] || [];

  // Slider settings
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: "150px",
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          centerPadding: "120px",
        },
      },
      {
        breakpoint: 768,
        settings: {
          centerPadding: "80px",
        },
      },
      {
        breakpoint: 554,
        settings: {
          centerPadding: "50px",
        },
      },
    ],
  };

  return (
    <div id="gallery" className="ProjectGallery_desktop-slide-container">
      <h2 className="ProjectGallery_desktop-title">PROJECT GALLERY</h2>
      <Slider {...settings} className="ProjectGallery_desktop-swiper">
        {images.length > 0 ? (
          images.map((image, idx) => (
            <div key={idx} className="ProjectGallery_desktop-slide">
              <img
                src={image.link}
                alt={image.alt}
                className="ProjectGallery_desktop-image"
                onError={() => console.error(`Image failed to load: ${image}`)}
              />
            </div>
          ))
        ) : (
          <div>No images available for this project.</div>
        )}
      </Slider>
    </div>
  );
};

const SampleNextArrow = (props) => {
  const { onClick } = props;
  return (
    <div
      className="ProjectGallery_desktop-arrow ProjectGallery_desktop-right-arrow"
      onClick={onClick}
    >
      <img src={rightArrow} alt="right arrow" />
    </div>
  );
};

const SamplePrevArrow = (props) => {
  const { onClick } = props;
  return (
    <div
      className="ProjectGallery_desktop-arrow ProjectGallery_desktop-left-arrow"
      onClick={onClick}
    >
      <img src={leftArrow} alt="left arrow" />
    </div>
  );
};

export default ProjectGalleryDesktop;
